import axios from "axios";
import { API_HOST } from "app/utils/constants/paths";

const versionServices = {};

// Va por axios pelado y no por jwtAuthAxios a proposito. El interceptor de
// jwtAuthAxios levanta un Swal ante cualquier respuesta con error, y esta llamada es
// decorativa: si el backend no contesta la version no hay nada que avisarle al
// usuario, y menos con un modal encima. El endpoint ademas es publico, no necesita
// el Bearer.
versionServices.getBackendVersion = async () => {
    const { data } = await axios.get(`${API_HOST}/version`);
    return data?.version || "dev";
};

export default versionServices;
